import { render, staticRenderFns } from "./ManagingRevenue.vue?vue&type=template&id=36b2bb46&scoped=true"
import script from "./ManagingRevenue.vue?vue&type=script&lang=js"
export * from "./ManagingRevenue.vue?vue&type=script&lang=js"
import style0 from "./ManagingRevenue.vue?vue&type=style&index=0&id=36b2bb46&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2bb46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b2bb46')) {
      api.createRecord('36b2bb46', component.options)
    } else {
      api.reload('36b2bb46', component.options)
    }
    module.hot.accept("./ManagingRevenue.vue?vue&type=template&id=36b2bb46&scoped=true", function () {
      api.rerender('36b2bb46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/ManagingRevenue.vue"
export default component.exports